import Request from '../Request.utils'
export interface IMergeImageRequestBody {
  data: {
    product: {
      physicalHeight: number;
      physicalWidth: number;
      printAreas?: {
        height: number;
        left: number;
        top: number;
        width: number;
      }[];
    };
  };
  images: string[];
}


class TestAPI {
  backendVersion = async () => {
    const res = await Request.call('/api/version', 'GET', undefined, undefined, undefined, );
    return res;
  }
  queueDelayTest = async () => {
    const res = await Request.call('/api/hello-world/queue-delay-test', 'GET', undefined, undefined, undefined, );
    return res;
  }
  queueDelayTestB = async () => {
    const res = await Request.call('/api/hello-world/queue-delay-test-b', 'GET', undefined, undefined, undefined, );
    return res;
  }
  mergeImage = async (body: IMergeImageRequestBody) => {
    const res = await Request.call('/b/api/test/merge-image', 'POST', undefined, undefined, body, );
    return res;
  }
  testXero = async () => {
    const res = await Request.call('/b/api/test/xero', 'POST', undefined, undefined, undefined, );
    return res;
  }
  testTwilio = async () => {
    const res = await Request.call('/api/hello-world/test-twilio', 'GET', undefined, undefined, undefined, );
    return res;
  }
}
export default new TestAPI()